/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent } from 'react';
import { userSelectors } from '../../../../../../../../../app/resource/user/user.selectors';
import { useSelectWithParams } from '../../../../../../../../../utils/selector.utils';
import { IUserImg } from './types';
import { CircularAvatar } from '../../../../../../CustomAvatar';

export const UserImg: FunctionComponent<IUserImg> = ({ userId }) => {
  const user = useSelectWithParams(userSelectors.selectResourceById, userId);
  return (
    user && (
      <a className="small-avatar mr-05">
        <CircularAvatar
          src={user.image}
          title={`${user.firstName} ${user.lastName}`}
          size="30"
          classes="img-fluid"
          styles={{ verticalAlign: 'baseline' }}
        />
      </a>
    )
  );
};
